<template>
  <ul class="c-header-nav-more-local">
    <app-header-nav-more-local-item
      v-for="(local, index) in locales"
      :key="index"
      :local="local"
      :current-local="currentLocal"
      :is-current-local="isCurrentLocal(local.code)"
    />
  </ul>
</template>

<script>
import { locales, currentLocal } from "src/i18n";
import AppHeaderNavMoreLocalItem from "components/AppHeader/AppHeaderNav/AppHeaderNavMore/AppHeaderNavMoreLocal/AppHeaderNavMoreLocalItem";
export default {
  components: {
    AppHeaderNavMoreLocalItem
  },
  computed: {
    locales() {
      return locales;
    },
    currentLocal() {
      return currentLocal;
    }
  },
  methods: {
    isCurrentLocal(local) {
      return local === this.currentLocal.code;
    }
  }
};
</script>

<style lang="scss">
.c-header-nav-more-local {
  @include reset-list;
  display: flex;
  flex-direction: row;
}
</style>
